import { FIELD_UNITS, SetupCall } from '@driscollsinc/driscolls-display-rules';
import { dateTimeSetupFields } from './CommonSetupFields';

function configureSetupCall() {
    SetupCall(
        'ItemUomConversion',
        [
            {
                name: 'ItemID',
                type: FIELD_UNITS.RAW
            },
            {
                name: 'Commodity',
                type: FIELD_UNITS.STRING
            },
            {
                name: 'BusinessUnit',
                type: FIELD_UNITS.STRING
            },
            {
                name: 'ItemListID',
                type: FIELD_UNITS.RAW
            },
            {
                name: 'EstimateGroup',
                type: FIELD_UNITS.STRING
            },
            {
                name: 'Description',
                type: FIELD_UNITS.STRING
            },
            {
                name: 'TrayToKilogram',
                type: FIELD_UNITS.NUMBER,
                options: { minimumFractionDigits: 2, maximumFractionDigits: 6 }
            },
            {
                name: 'Lang',
                type: FIELD_UNITS.STRING
            },
            ...dateTimeSetupFields
        ],
        {}, //options
        (data) => {
            console.log('Item Uom Conversion REDUCER-- ', data);
        }
    );
}

const ItemUomConversion = {
    configureSetupCall
};

export default ItemUomConversion;
